module.exports = {

	headView: {
		headView_lbl0: '公式サイトTOP',
		headView_lbl1: '予約サイトTOP',
		headView_lbl2: 'マイページ',
		headView_lbl3: 'Login',
		headView_lbl4: 'Languages',
		headView_lbl5: '日本語',
		headView_lbl6: '中国語',
		headView_lbl7: '06-6710-9972',
		headView_lbl8: '営業時間：9:00〜19:00（18:00最終受付）定休日：年中無休',
		headView_lbl9: 'マイページ',
		headView_lbl10: 'ログアウト',
		headView_lbl11: 'ログアウトします。よろしいですか？',
		headView_lbl12: 'はい',
		headView_lbl13: 'いいえ',
		headView_lbl14: '英語',

	},

	calendar: {
		calendar_lbl0: 'Reserve from Calendar',
		calendar_lbl1: 'カレンダー予約-ご希望の日程をクリックしてください。',
		calendar_lbl2: 'Car Line Up',
		calendar_lbl3: '車種から選ぶ',
		calendar_lbl4: '休日のため、予約できません。',
		calendar_lbl5: '過去の日付を予約できません。',
		calendar_lbl6: 'ネットワーク接続に失敗しました。ページを更新してもう一度お試しください！',


	},

	carline: {
		carline_1: 'Car Line Up',
		carline_2: 'ご予約可能な車種',
		carline_3: '車種情報を見る'
	},
	buttom: {

		buttom_lbl0: '電車でお越しの際は、JR・大阪Metro「大正駅」まで、スタッフがお迎えに上がります。',
		buttom_lbl1: '〒551-0031 大阪府大阪市大正区泉尾4丁目12-21',
		buttom_lbl2: '© 2022 MR.HIROレンタカー All Rights Reserved.',

	},
	login: {

		login_lbl0: 'Login',
		login_lbl1: '会員ログイン',
		login_lbl2: 'ログインしたままにする',
		login_lbl3: 'ログイン',
		login_lbl4: 'まだアカウントを持っていない方は、今すぐ登録を！',
		login_lbl5: 'パスワードをお忘れの方はこちら',
		login_lbl6: '表单验证失败',
	},
	carlinedetail: {
		carline_1: 'カレンダーを見る',
		carline_2: '乗車定員',
		carline_3: 'トランスミッション',
		carline_4: 'ハンドル',
		carline_5: '排気量',
		carline_6: '最高出力',
		carline_7: '快適人数',
		carline_8: '駆動方式',
		carline_9: '全長×全幅×全高',
		carline_10: '装 備',
		carline_11: '備考欄',
		carline_12: '管理者が車についての備考を記入できるスペースです。',
		carline_13: '◯◯◯◯◯◯◯◯◯◯◯◯◯',
		carline_14: 'この車を予約する',
		carline_15: 'ゲストとして予約',
		carline_16: '会員登録して予約',
		carline_17: 'コース'
	},
	ReserveCar: {
		ReserveCar_1: 'Reserve',
		ReserveCar_2: 'ご予約',
		ReserveCar_3: '予約車種',
		ReserveCar_4: '予約希望日',
		ReserveCar_5: '予約開始希望時間',
		ReserveCar_6: '予約希望コース',
		ReserveCar_7: '複数日追加延長オプション',
		ReserveCar_8: '乗車人数',
		ReserveCar_9: '乗車人数（6歳未満のお子様）',
		ReserveCar_10: '姓',
		ReserveCar_11: '名',
		ReserveCar_12: '電話番号',
		ReserveCar_13: 'メールアドレス',
		ReserveCar_14: 'メールアドレス（確認用）',
		ReserveCar_15: '国籍または地域',
		ReserveCar_16: '運転免許の種類',
		ReserveCar_17: '保険++',
		ReserveCar_18: 'お支払い方法',
		ReserveCar_19: '運転免許取得年数',
		ReserveCar_20: '追加する ※400km ',
		ReserveCar_21: '日本の運転免許証',
		ReserveCar_22: 'SOFA License for USFJ',
		ReserveCar_23: 'Switzerland, Germany, France, Taiwan, Belgium, Slovenia, Monaco Domestic Driving License with Japanese Translation by authorizedorganization.',
		ReserveCar_24: 'International Driving Permit by the 1949 Geneva Convention',
		ReserveCar_25: '事前支払い（クレジットカード）',
		ReserveCar_26: '当日支払い（クレジットカード及び現金可）',
		ReserveCar_27: 'カード番号',
		ReserveCar_28: 'セキュリティーコード',
		ReserveCar_29: '有効期限（月/年）',
		ReserveCar_30: 'カード名義人（名）',
		ReserveCar_31: 'カード名義人（姓）',
		ReserveCar_32: 'メールアドレス',
		ReserveCar_33: '電話番号',
		ReserveCar_34: '免許取得年数3年以上',
		ReserveCar_35: '確認画面へ',
		ReserveCar_36: '前回のクレジットカード',
		ReserveCar_37: 'データがありません',
		
		ReserveCar_38: '免許取得年数3年未満',
		
		ReserveCar_39:'運転免許取得年数が３年未満の場合はプレミアムプランのみ選択できます。',
		
		ReserveCar_40:'{name}を選んだ方はプレミアムプランのみ選択できます。',
		ReserveCar_41:'ご予約申請いただいたところ大変申し訳ないのですが、免許取得年数が3年未満のお客様は原則、予約を見送らせていただきます。',
		ReserveCar_42:'※免許取得年数3年未満での予約ご希望の場合は、ご来店またはお電話でお問い合わせください。',
		ReserveCar_43:'06-6710-9972',
		ReserveCar_44:'〒551-0031',
		ReserveCar_45:'大阪府大阪市大正区泉尾4丁目12−21',
		ReserveCar_46:'営業時間：9:00〜19:00（18:00最終受付）定休日：年中無休',
		ReserveCar_47:'ご予約申請いただいたところ大変申し訳ないのですが、【{name}】を選択し且つ免許取得年数が3年未満お客様は原則、予約を見送らせていただきます。',
		ReserveCar_48:'※予約ご希望の場合は、メールにてお問い合わせください。',
		ReserveCar_49:'06-6710-9972',
		ReserveCar_50:'mrhirojdm@gmail.com',
		ReserveCar_51:'〒551-0031',
		ReserveCar_52:'大阪府大阪市大正区泉尾4丁目12−21',
		
		ReserveCar_53:'営業時間：9:00〜19:00（18:00最終受付）定休日：年中無休',
		ReserveCar_54:'万が一、免許取得年数3年未満の方で、免許取得3年以上を選択し、ご予約頂いた場合、原則お車のレンタルはできません。またキャンセル料金が発生します。ご自身の運転免許証取得年月日をご確認の上ご予約頂きますようお願い致します。',
		ReserveCar_55:' (平日限定)※100km ',
		ReserveCar_56:' ※200km ',
		ReserveCar_57:' ※350km ',
		ReserveCar_58:' ※400km ',
		ReserveCar_59:'※各プラン毎に距離制限がございます。距離超過1km毎に500円。',
		ReserveCar_60:'利用規約確認済',
		ReserveCar_61:'万が一禁止行為（※利用規約第18条）の運転で事故が起きた際に、保険对象外となる為に車両金額として￥{pay}を支払いいただく場合があります。',
		ReserveCar_62:'はい',
		ReserveCar_63:'同意する',
		ReserveCar_64:'確認事項',
		ReserveCar_65:'また時間超過は、午後7時迄10分毎に1000円、午後7時以降10分毎に2000円いただきます。',
		ReserveCar_66:'受付時間に30分程かかります。こちらもレンタル時間に含まれるますので、ご了承下さい。',
		ReserveCar_67:'オプション内容',
		ReserveCar_68:'写真撮影(15カット/19,800円)',
		ReserveCar_69:'動画撮影(約120秒/34,500円)',
		ReserveCar_70:'写真効果参照',
		ReserveCar_71:'動画効果参照',
		ReserveCar_72:'ｵﾌﾟｼｮﾝの項目：',
		ReserveCar_73:'チャイルドシート無料（0円）',
		ReserveCar_74:'（0歳～6未満の幼児は着用義務あり）',
		ReserveCar_75:'写真撮影・動画撮影オプションのご利用料金は、レンタカーの利用料金とは別に、当日店頭にてお支払いいただきます。',
		ReserveCar_76:'なお、お申し込みいただいた日程にオプションをご利用いただけない場合は、予約確認メールとは別途、メールにてご連絡いたします。',
		ReserveCar_77:'（21歳以上）'
	},

	ResetPassword: {
		ResetPassword_lbl0: '新規登録',
		ResetPassword_lbl1: 'パスワードをお忘れの方',
		ResetPassword_lbl2: 'メールアドレス',
		ResetPassword_lbl3: 'メール認証コード',

		ResetPassword_lbl4: '認証コードを取得する',
		ResetPassword_lbl5: 'パスワードは6桁から18桁の数字で、大文字、小文字、数字を含むこと。',
		ResetPassword_lbl6: '登録する',
		ResetPassword_lbl7: 'パスワード',

	},

	Register: {
		Register_lbl0: 'Sign Up',
		Register_lbl1: '新規ユーザー登録',
		Register_lbl2: 'メールアドレス',
		Register_lbl3: 'メール認証コード',
		Register_lbl4: '認証コードを取得する',
		Register_lbl5: 'パスワード',
		Register_lbl6: 'パスワードは6桁から18桁の数字で、大文字、小文字、数字を含むこと。',
		Register_lbl7: '私は、登録同意書およびプライバシーポリシーを読み、同意します。',
		Register_lbl8: '登録する',
		Register_lbl9: 'すでにアカウントをお持ちの方は',
		Register_lbl10: 'ログイン',
		Register_lbl11: 'をクリックしてください。',


		Register_lbl12: 'メールアドレスを入力してください。',
		Register_lbl13: '正しいメールアドレスを入力してください。',
		Register_lbl14: '認証コードを入力してください。',
		Register_lbl15: 'パスワードを入力してください。',
		Register_lbl16: '登録完了しました。',
		Register_lbl17: 'ログインすることにより、以下に同意いただいたものとします：利用規約＆プライバシーポリシー',
		Register_lbl18: 'ログインしました。',
		Register_lbl19: '該当アカウントは存在しておりません。',
		Register_lbl20: '正しいパスワードを入力してください。',
		Register_lbl21: 'ネットワークエラー',
		Register_lbl22: '該当アカウントは既に存在しております。',
		Register_lbl23: 'データ登録失敗しました。',
		Register_lbl24: 'パスワードを変更しました。',
		Register_lbl25: 'パスワードを変更できませんでした。',
		Register_lbl26: '確認用パスワードが一致しません。',
		Register_lbl27: '姓を入力してください。',
		Register_lbl28: '名を入力してください。',
		Register_lbl29: '認証コード送信',
	},

	Reservesure: {
		Reservesure_1: '合 計',
		Reservesure_2: 'この内容で予約する',
		Reservesure_3:'なし',
		Reservesure_4:'内容を訂正する'
	},
	Reservesub: {
		Reservesub_1: 'Thank You !',
		Reservesub_2: 'ご予約が完了致しました。',
		Reservesub_3: 'ご記載頂きましたメールアドレス宛に「ご予約完了メール」を送信致しましたので、',
		Reservesub_4: 'ご確認をお願いいたします。',
		Reservesub_5: 'ご予約に失敗しました。',
		Reservesub_6: 'UNIVAPAYで支払い失敗の原因をご確認ください、',
		Reservesub_7: '再度ご予約をお願いいたします',
	},
	infoview: {
		infoview_1: 'MENU',
		infoview_2: 'ユーザー情報',
		infoview_3: 'ご注文について',
		infoview_4: 'パスワードの変更',
		infoview_5: 'マイポイント'
	},
	UserInfo: {
		UserInfo_1: 'User Information',
		UserInfo_2: 'ユーザー情報',
		UserInfo_3: 'メールアドレス',
		UserInfo_4: '電話番号',
		UserInfo_5: '姓',
		UserInfo_6: '名',
		UserInfo_7: '身分証明書',
		UserInfo_8: '身分証明書番号',
		UserInfo_9: '生年月日',
		UserInfo_10: '緊急連絡先氏名',
		UserInfo_11: '緊急連絡先電話番号',
		UserInfo_12: '登録する',
		UserInfo_13: 'クレジットカード情報：',
		UserInfo_14: '登録済み',
		UserInfo_15: '未登録',
		UserInfo_16: 'クレジットカード情報変更',
		UserInfo_17: 'カード登録',
		UserInfo_18: 'クレジットカード情報の変更',
		UserInfo_19: 'カード番号を入力してください。',
		UserInfo_20: 'セキュリティコードを入力してください。',
		UserInfo_21: '力一卜会員名(名)を入力してください。',
		UserInfo_22: '力一卡会員名(姓)を入力してください。',
		UserInfo_23: 'メールアドレスを入力してください。',
		UserInfo_24: '電話番号',
		UserInfo_25: 'データ登録に成功しました。',
	},
	OrderInfo: {
		OrderInfo_1: '予約履歴',
		OrderInfo_2: '注文番号',
		OrderInfo_3: '車 種',
		OrderInfo_4: 'レンタル開始時間',
		OrderInfo_5: '利用時間',
		OrderInfo_6: '支払方法',
		OrderInfo_7: 'データがありません',
	},

	ModifyPwd: {
		ModifyPwd_lbl0: 'パスワードの変更',
		ModifyPwd_lbl1: '認証コード',
		ModifyPwd_lbl2: '認証コードを送信',
		ModifyPwd_lbl3: 'パスワード',
		ModifyPwd_lbl4: '確認用パスワード',
		ModifyPwd_lbl5: '登録する',

	},
	OrderInfoDetail: {
		OrderInfoDetail_1: '合計金額',
		OrderInfoDetail_2: '以下の内容で宜しければページ最下部「この内容で予約する」ボタンからご予約を完了してください。',
		OrderInfoDetail_3: '人',
		OrderInfoDetail_4:'なし'
	},
	Points: {
		Points_1: 'ポイント照会',
		Points_2: 'ポイントについて',
		Points_3: '使えるポイント',
		Points_4: 'ポイント規則',
		Points_5: 'ポイント付与日時',
		Points_6: '取引の種類',
		Points_7: 'ポイント数',
	},
	bx: {
		bx_1: '車両補償なし',
		bx_2: '基本プラン+3000円/日',
		bx_3: '安心ブラン＋5000円/日',
		bx_4: '補償内容:',
		bx_5: '対人補償：',
		bx_6: '無制限',
		bx_7: '車両補償負担額：',
		bx_8: '修理費用全額負担',
		bx_9: '対物補償：',
		bx_10: '20万円',
		bx_11: '人身傷害1名につき3000万円まで：',
		bx_12: '上記自己負担及び補償限度額を超える損害はお客様の負担となります。保険約款の保険金を支払いできない事由に該当する事故の場合、補償されません。警察の発行する事故番号がない場合も補償されません。',
		bx_13: '万一、事故およびお客様の過失による車両故障の場合には、車両修理費および修理期間中の休業補償の一部として、上記の基本金額をご負担頂きます。損傷の程度や修理の所要時間によって、ご負担額が変動いたします。（時価額のため）ご了承くだごい。',
		bx_14: 'ノンオペレーションチャージ',
		bx_15: '自走にて営業所へ返却された場合',
		bx_16: '15万円',
		bx_17: '自走にて営業所へ返却されなかった場合',
		bx_18: '30万円',
		bx_19: '50万円',
		bx_20: 'ノンオペレーションチャージ',
		bx_21: '保険加入されない場合はお客様の自動車保険証券（原本）をご提示ください。ご提示のない場合はお貸しできませんので、ご了承权がいます.',
	},
	bc:{
		bc_1:'電話番号を入力してください。',
		bc_2:'姓を入力してください。',
		bc_3:'名を入力してください。',
		bc_4:'身分証明書を入力してください。',
		bc_5:'身分証明書番号を入力してください。',
		bc_6:'生年月日を入力してください。',
		bc_7:'緊急連絡先氏名を入力してください。',
		bc_8: '緊急連絡先電話番号を入力してください。',
		bc_9: '正しいパスワードを入力してください。',
		bc_10: '予約開始時間を入力してください。',
		bc_11: 'コースを入力してください。',
		bc_12: '乗車人数を入力してください。',
		bc_13: 'メールアドレス（確認用）',
		bc_14: '確認用メールアドレスが一致しません。',
		bc_15: '国籍または地域を入力してください。',
		bc_16: '運転免許の種類を入力してください。',
		bc_17: '保険オプションを入力してください。',
		bc_18: 'お支払い方法を入力してください。',
		bc_19: '予約成功しました。',
		bc_20: '予約失敗しました。',
		bc_21: '名',
		bc_22: 'cc',
		bc_23:'ps',
		bc_24:'該当アカウントは存在しておりません。',
		bc_25:'指定人数を超えています。',
		bc_26:'カード番号を入力してください。',
		bc_27:'セキュリティコードを入力してください。',
		bc_28:'有効期限（月）を入力してください。',
		bc_29:'有効期限（年）を入力してください。',
		bc_30:'カード名義人（名）',
		bc_31:'カード名義人（姓）',
		bc_32:'メールアドレス',
		bc_33:'１名以上の乗車人数を入力してください。',
		bc_34:'運転免許取得年数を入力してください。',
		bc_35:'データ登録が失敗しました。入力情報を確認してください。',
		bc_36:'アカウントまたはパスワードが正しくありません。',
		bc_37:'データ登録が失敗しました。入力情報を確認してください。',
		bc_38:'必須項目を入力してください。',
		bc_39:'該当メールアドレスは既に登録されています。',
		bc_40:'認証コードを入力してください。',
		bc_41:'データ登録が失敗しました。もう一度お試しください。',
		bc_42:'Password',
		bc_43:'1～12の数字を入力してください。',
		bc_44:'カード名義人（姓）を入力してください。',
		bc_45:'カード名義人（名）を入力してください。',
		bc_46:'認証コードを送信しました',
		bc_47:'正しい電話番号を入力してください。',
		bc_48:'正しい生年月日を入力してください。',
		bc_49:'ログイン中',
		bc_50:'しばらくお待ちください。',
		bc_51:'予約処理中',
		bc_52:'データ送信中',
		bc_53:'正しい認証コードを入力してください。',
		bc_54:'正しい有効期限を入力してください。',
		bc_55:'該当日時はすでに予約されていますため、処理できません。もう一度お試しください。',
		bc_56:'確認事項を確認してください。',
	},
	agree:{
		agree1:'MR.HIRO POINT会員規約',
		agree2:'株式会社日恵（以下、「当社」といいます。）は当社の定める手続きを完了させた会員が、当社の運営・提供するサービス（以下、「本サービス」といいます。）を利用するにあたり、以下のとおり「MR.HIROPOINT会員規約」（以下、「会員規約」といいます。）を定めます。',
		agree3:'第１条（適用範囲）',
		agree4:'会員規約は、本サービスのご利用に関して、当社と会員に適用されるものとします。',
		agree5:'第２条（用語の定義）',
		agree6:'会員規約に定める主な用語の定義は、次の各号に掲げるとおりとします。',
		agree7:'⑴　「HIROPOINT」とは、当社からHIRO　POINT会員に対して付与するポイントの名称をいい、HIRO　POINTとして付与又は利用される個々のポイントは、以下単に「ポイント」といいます。',
		agree8:'⑵　「POINTアプリ」とは、当社が提供したHIRO POINT会員資格の登録及びHIRO POINTの利用等に供するスマートフォン用のアプリをいいます。',
		agree9:'⑶　「会員ID情報」とは、POINTアプリを利用する際に登録したユーザーID、パスワード、E-Mailアドレス及びその他のPOINTアプリを利用するにあたって会員本人を特定するために必要な当社所定の情報をいいます。',
		agree10:'⑷　「ポイント残高」とは、HIRO　POINTのサービスの利用によりポイント口座に積み立てられたポイント数をいいます。',
		agree11:'第３条（会員資格）',
		agree12:'⑴　会員希望者は、POINTアプリを通じて当社の会員規約に同意の上、当社が定める所定の手続きを行い会員登録するものとし、当社のシステムに会員情報が登録された時点で、当該会員希望者の会員登録が完了するものとします。ただし、会員情報の記載漏れがあった場合には、会員登録を完了することができないことがあります。',
		agree13:'⑵　会員規約に同意いただけない場合には、会員になることはできません。また、暴力団員、暴力団準構成員、暴力団関係者、暴力団関係企業又は総会屋等その他の反社会的勢力（以下「反社会的勢力」といいます。）の構成員（過去５年以内に構成員だった場合を含みます。）及びその関係者、又は、サービスの悪用若しくは第三者に迷惑をかける行為を行う者等については、ご利用をお断りしています。',
		agree14:'⑶　会員希望者が、第１２条に定める内容に該当することが判明した場合は、会員登録はできません。また、第１２条に定める内容に該当することが判明した場合は、会員登録が完了したときであっても、当社は当該会員の資格を停止又は取消すことができるものとします。',
		agree15:'⑷　HIRO　POINTのサービスは個人を対象としているため、法人は会員となることはできません。',
		agree16:'第４条（ID・パスワードの管理）',
		agree17:'⑴　会員は、会員ID情報を、責任を持って管理するものとします。',
		agree18:'⑵　会員は、会員ID情報を第三者に使用させたり、貸与、譲渡、名義変更、売買、質入等その他いかなる処分もしてはならないものとします。',
		agree19:'⑶　当社は、正当な会員ID情報が使用された手続き・操作等については、会員本人が行ったものとみなすものとします。第三者が会員ID情報を使用したことによる損害の負担は会員が負うものとし、当社は一切の責任を負わないものとします。',
		agree20:'⑷　会員は、会員ID情報が漏洩し、会員ID情報が第三者に使用されていることを知った場合は、速やかに当社に連絡するとともに、当社からの指示がある場合には、これに従うものとします。',
		agree21:'第５条（会員情報及び会員ID情報の変更）',
		agree22:'⑴　会員情報又は会員ID情報に変更が生じた場合は、POINTアプリにて登録情報の変更手続きを行うか、当社まで申し出るものとします。',
		agree23:'⑵　前項における変更手続きがなされない場合、必要な連絡及び通知が届かず、ポイント付与等のサービスが受けられなくなることがあります。なお、変更手続きがなされなかったことにより、会員が何らかの損害を被ったとしても、当社はその賠償の責を一切負わないものとします。',
		agree24:'第６条（ポイント付与）',
		agree25:'当社は、会員に対し以下の条件でポイントを付与するものとします。なお、いずれの条件の場合も、購入商品、サービス内容又は支払方法によりポイント付与を行わない場合があります。',
		agree26:'⑴　当社の事業所において所定の手続きを経た上で行われるポイント購入',
		agree27:'⑵　前号の購入に付帯するポイント付与',
		agree28:'⑶　キャンペーンその他当社が定める方法',
		agree29:'第７条（ポイントの有効期限）',
		agree30:'ポイントの有効期限は、ポイントの付与、利用等により、前条によりポイントが付与された日から６か月とします。',
		agree31:'第８条（ポイントの利用）',
		agree32:'⑴　会員は、付与されたポイントを「１ポイント=１円」として当社の商品購入時又はサービス利用時の代金の全部又は一部への充当することができます。',
		agree33:'⑵　ポイントの換金、払戻しは行いません。',
		agree34:'第９条（ポイント譲渡の禁止）',
		agree35:'会員は、会員が保有するポイントを他人に譲渡、貸与し、又はこれらに担保を設定することはできないものとします。また、会員は、他の会員が保有するポイントを譲り受け、又は借り受けることはできないものとします。ただし、当社が定める手続きに従って行う場合を除きます。',
		agree36:'第１０条（ポイントの取消・失効・修正）',
		agree37:'⑴　会員は、POINTアプリを通じて、当社所定の方法よりポイントを使用することができることとします。',
		agree38:'⑵　ポイント残高は、POINTアプリを通じて記録された当社のシステム内に保存されたデータ（以下「本データ」といいます。）によって定まるものとします。POINTアプリ上に表示されたデータと本データとが異なる場合、本データのポイント残高を有効なものとして取り扱うことにつき、会員はあらかじめ了承します。',
		agree39:'⑶　当社が、会員に対し誤ってポイントを付与した場合その他適切なポイント残高に修正すべき事由が存在する場合、当社は当社の裁量において正しいポイント残高に修正することができるものとします。',
		agree40:'⑷　次の各号のいずれかに該当した場合、当該事由に該当した時点で、当該時点のポイント残高の全てが失効し、ポイントのご利用ができなくなるものとします。なお、いかなる理由があっても失効したポイントの再付与は行いません。',
		agree41:'　①　第７条に定めるポイントの有効期限を経過した場合',
		agree42:'　②　会員が退会又は会員資格を喪失した場合',
		agree43:'　③　その他当社がポイントを失効させることが適切であり必要であると判断した場合',
		agree44:'第１１条（退会）',
		agree45:'会員は随時退会できるものとし、退会に際しては当社所定の手続きを行うものとします。退会時までに付与されたポイントは退会手続き完了と同時に失効するものとします。なお、いかなる理由があっても失効したポイントの再付与は行いません。',
		agree46:'第１２条（強制退会事由等）',
		agree47:'⑴　当社は、会員が以下の各号のいずれかに該当するとき、会員の資格を停止し、又は喪失させることができるものとします。また、当社は、会員が以下の各号のいずれかに該当する疑義があるとき、当該疑義が解消されるまでの間、会員資格を停止することができるものとします。なお、会員の資格を喪失した場合、資格の喪失と同時に、それまでに当該会員に付与されたポイントは失効するものとします。',
		agree48:'　①　会員規約又は当社が別に定める規約・特約等に違反した場合',
		agree49:'　②　会員が第11条により退会した場合',
		agree50:'　③　会員が反社会的勢力であることが判明した場合（過去５年以内に構成員だった場合を含みます。）',
		agree51:'　④　会員が実在しない場合(死亡した場合を含む)',
		agree52:'　⑤　会員が過去に会員規約違反等により、会員資格が停止され、又は喪失されている場合',
		agree53:'　⑥　会員登録手続きの際に当社に届け出た事項に虚偽・誤記又は記入漏れがあった場合',
		agree54:'　⑦　会員が後見、保佐、補助開始の審判を受けており、成年後見人、保佐人、補助人の同意を得ていない場合',
		agree55:'　⑧　不正利用、その他正常でない方法でポイントが付与され又は利用された場合',
		agree56:'　⑨その他、当社が会員として不適格であると判断した場合',
		agree57:'⑵　当社は、当社に届け出た住所、電話番号又は電子メールアドレス等の変更により、連絡が取れなくなった会員についても、会員の資格を喪失させることがあります。',
		agree58:'⑶　当社は、会員となった日又は最後にポイント残高が変動した日から１年後の月末まで、一切ポイント残高の変動が無い会員についても、会員の資格を喪失させることがあります。',
		agree59:'第１３条（サービスの中断及び終了）',
		agree60:'⑴　当社は、次の各号に該当する場合に、HIRO　POINTのサービスを中断又は終了することができるものとします。',
		agree61:'　①　HIRO　POINTのサービスの提供に必要な設備の保守・点検を行う場合、又は障害が発生した場合',
		agree62:'　②　当社が、HIRO　POINTのサービスの中断又は終了を判断した場合',
		agree63:'　③　その他、やむを得ない事情がある場合',
		agree64:'⑵　当社は、HIRO　POINTのサービスの中断又は終了に伴って会員に生じた損害その他いかなる不利益について、一切の責任を負いません。',
		agree65:'⑶　当社は、HIRO　POINTのサービスを中断又は終了するときには、HIRO　POINTアプリ等で告知するものとします。ただし、HIRO　POINTのサービスの中断又は終了が緊急に必要となった場合、その他やむを得ない事情がある場合には、この限りではありません。',
		agree66:'第１４条（会員の個人情報の収集・利用・提供）',
		agree67:'【会員の個人情報の収集・利用・提供に関する同意】',
		agree68:'会員は、第２項に示す会員の情報を、第３項に定める利用目的のため、当社が必要な保護措置を講じた上で収集、利用することに同意します。',
		agree69:'【収集・利用・提供する個人情報項目】',
		agree70:'当社は、第３項に定める利用目的のため、以下の会員の個人情報を利用します。',
		agree71:'　①氏名、住所、電話番号、生年月日、性別、E-Mailアドレス等、会員が入会申込時に届けた事項及び入会後に届けた事項',
		agree72:'　②入会日、会員証の番号等、会員と当社の契約に関する事項会員のHIRO　POINTのサービスの利用内容（ポイント付与及び利用に関する履歴、購買履歴（利用日時、利用店舗、利用金額、購入商品、決済手段等）、HIRO　POINT会員情報が紐づく各種サービスの履歴等を含みます。）及び電話等での問合せ等により当社が知り得た情報（通話内容を含みます。）',
		agree73:'　③官報や電話帳等一般に公開されている情報',
		agree74:'　④POINTアプリを利用・閲覧した場合のIPアドレス、位置情報、端末の固体識別番号等の情報',
		agree75:'【当社の個人情報の利用目的】',
		agree76:'　①HIRO　POINTのサービスの提供及びポイント等の提供を行うため。',
		agree77:'　②HIRO　POINTのサービスの利用状況を分析し、市場調査、商品開発、お客さまの趣味、嗜好に応じたマーケティングを行うため。',
		agree78:'　③取得した閲覧履歴や購買履歴等の情報を分析し、当社及び提携先等が営む事業における商品、ポイント特典、サービスに関する宣伝物等の送付、広告の展開及びそれに付随する営業案内を行うため。',
		agree79:'　④会員への取引上必要な連絡及び取引内容の確認を行うため。',
		agree80:'　⑤当社と第５項に基づき個人情報を共同利用する者の行う会員組織の登録及び維持管理を行うため。',
		agree81:'　⑥HIRO　POINTのサービスを提供する目的において、法令の手続きに従って第三者への提供を行うため。',
		agree82:'　⑦その他上記各目的に準ずるか、これらに関連する目的のため。',
		agree83:'【個人情報の第三者への提供】',
		agree84:'当社は、第２項に示す会員の個人情報を、第３項各号に定める目的を達成するために必要な限度において、関係会社等に対して提供します。個人情報を、特定のグループ会社又はテナント等のみに提供し、その他のグループ会社又はテナント等には提供しないという申し出には応じかねます。',
		agree85:'【第三者提供の例外】',
		agree86:'以下の場合は、会員の事前承諾なしに、第三者に個人情報を提供する場合があります。',
		agree87:'　①法令に基づく場合',
		agree88:'　②人の生命、身体又は財産の保護のために必要がある場合であって、本人の承諾を得ることが困難である場合',
		agree89:'　③公衆衛生の向上、又は児童の健全な育成のために特に必要がある場合であって、本人の承諾を得ることが困難である場合',
		agree90:'　④国の機関、地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の承諾を得ることによって当該事務の遂行に支障を及ぼす恐れのある場合',
		agree91:'【個人情報の業務委託】',
		agree92:'当社は、第２項に示す会員の個人情報を、第３項に定める利用目的の達成に必要な範囲内において、当社が業務を委託する第三者に提供することがあります。',
		agree93:'【個人情報の取扱いに関する不同意】',
		agree94:'当社は、会員が入会の申込みに必要な事項の記載を希望しない場合及び本同意条項の内容の全部又は一部を承諾できない場合は、入会をお断りすることや退会の手続きをとることがあります。',
		agree95:'【個人情報に関するお問合せ先】',
		agree96:'個人情報に関するお問合せ及びご意見は、当社本社にて受け付けます。',
		agree97:'第１５条（規約の変更等）',
		agree98:'当社は、法令に定める範囲内で、会員規約を変更できるものとします。当該変更は、ＰＯＩＮＴアプリ等で原則60日前までに告知するものとします。ただし、会員の利益に適合するときは、この限りではありません。会員規約の変更後は、変更後の内容のみ有効となります。',
		agree99:'第１６条（免責事項）',
		agree100:'⑴　当社は、当社の故意又は重過失による場合を除き、HIRO　POINTのサービスに起因して発生した会員の損害については、一切の責任を負わないものとします。',
		agree101:'⑵　当社がHIRO　POINTのサービスに関して会員に対し損害賠償責任を負う場合、当社が賠償する損害は、通常かつ直接の損害に限るものとし、当社はいかなる場合であっても、間接損害、特別損害、付随的損害、派生的損害、逸失利益、使用機会の喪失による損害についての責任は負わないものとします。',
		agree102:'第１７条（準拠法）',
		agree103:'会員規約及びHIRO　POINTのサービスの利用に係る契約の成立、効力、履行及び解釈に関しては、日本法に準拠するものとします。',
		agree104:'第１８条（紛議解決）',
		agree105:'HIRO　POINTのサービスに関連して、会員と当社との間で発生した問題について解決しない場合には、大阪地方裁判所を第一審の専属的合意管轄裁判所とします。',
		agree106:'第１９条（施行・有効開始日）',
		agree107:'会員規約は、日本標準時間２０２２年１２月１日午前０時０分より有効とします。',
		agree108:'以上'
	}



}
